import { Logger } from './logger'

// Both the boot path (`app.user`, TAppUser — numeric id) and the auth hook (TUser — string id) feed
// the logger user context. They share the same rule, so it lives here: id `0` (or missing) is the
// backend's anonymous/unregistered sentinel — clear the context; a real id sets it.
type TLoggerUserSource = {
    id: string | number
    email?: string
    username?: string
}

const isAnonymous = (id: string | number): boolean => !id || String(id) === '0'

export const syncLoggerUser = (user: TLoggerUserSource | null | undefined): void => {
    if (!user || isAnonymous(user.id)) {
        Logger.removeUser()

        return
    }

    Logger.setUser({ id: String(user.id), email: user.email, username: user.username })
}
